<template>
  <vx-card
      :title="config.name"
      title-color="primary"
  >
    <div
        slot="header"
        class="vx-card__header"
    >
      <div class="vx-card__title">
        <h4>{{ config.name }}</h4>
      </div>
      <div class="vx-card__actions">
        <slot name="actions">
          <div class="vx-card__action-buttons">
            <feather-icon
                v-b-tooltip="'Migrar configuraciones de un nivel'"
                icon="ArrowUpRightIcon"
                class="ml-4"
                @click="migrateParameter()"
            />
          </div>
        </slot>
      </div>
    </div>
    <!-- collapse -->
    <app-collapse
        id="faq-payment-qna"
        type="margin"
        class="mt-2"
        v-for="(parameter, index) in config.extra.parameters"
        v-bind:key="index"
    >
      <ConfigListItem
          :application="application"
          :selected-user-id="selectedUserId"
          :key="index"
          :configurations="configurations"
          :param="parameter"
      />
    </app-collapse>
    <b-modal
        id="migration-modal"
        ref="migration"
        title="Migrar"
        hide-footer
        no-close-on-backdrop
    >
      <div class="row mb-5">
        <div class="col-md-12 mt-3">
          <label>Ambiente destino</label>
          <v-select
              v-model="selectedAmbients"
              multiple
              label="title"
              :options="ambientsOptions"
          />
        </div>
        <div class="col-md-12 mt-3">
          <label>Niveles</label>
          <v-select
              v-model="selectedLevels"
              label="id"
              :options="levels"
          >
            <template #option="{ id }">
              <span> {{ id |capitalize() }}</span>
            </template>
          </v-select>
        </div>
        <div class="col-md-12 mt-3">
          <div style="float: right">
            <b-spinner
                class="mr-1"
                variant="primary"
                v-if="sendingMigration"
            />
            <vs-button
                class="action"
                color="primary"
                type="border"
                icon="save"
                @click="sendMigrateParameter"
                v-if="!sendingMigration"
            >
              Migrar
            </vs-button>
          </div>
        </div>
      </div>
    </b-modal>
  </vx-card>
</template>

<script>
import ConfigListItem from './ConfigListItem';

import AppCollapse from '@core/components/app-collapse/AppCollapse';
import { ioMigrateConfigurations } from '@/febos/servicios/api/herramientas.api';
import { levels } from '@/febos/global/utils/configurations';

const posiblesAmbientes = [
  { title: 'Desarrollo', value: 'desarrollo' },
  { title: 'Pruebas', value: 'pruebas' },
  { title: 'Certificación', value: 'certificacion' },
  { title: 'Produccion', value: 'produccion' }
];

export default {
  name: 'ConfigList',
  components: {
    AppCollapse,
    ConfigListItem
  },
  data() {
    return {
      selectedAmbients: [],
      selectedLevels: undefined,
      levels,
      loading: false,
      sendingMigration: false
    };
  },
  computed: {
    ambientsOptions() {
      return posiblesAmbientes.filter((ambient) => ambient.value !== process.env.VUE_APP_AMBIENTE);
    }
  },
  methods: {
    migrateParameter() {
      this.selectedAmbients = [];
      this.selectedLevels = {};
      this.$refs.migration.show();
    },
    async sendMigrateParameter() {
      if (this.selectedAmbients.length === 0 || !this.selectedLevels) {
        return;
      }
      this.sendingMigration = true;
      try {
        const ambients = this.selectedAmbients.map((ambiente) => ambiente.value);
        const level = this.selectedLevels.id;
        const parameter = this.config.extra.parameters.map((param) => param.parameter_id);
        await ioMigrateConfigurations({
          parameter, level, ambients, app: this.application, usuarioId: this.selectedUserId
        });
        this.$refs.migration.hide();
      } finally {
        this.sendingMigration = false;
      }
    }
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    selectedUserId: {
      type: String,
      required: false
    },
    application: {
      type: String,
      required: true
    },
    configurations: {
      type: Object,
      required: true
    }
  }
};
</script>
